/**
 * CloudWatch RUM Initialization
 *
 * This script initializes AWS CloudWatch RUM (Real User Monitoring) for frontend
 * error tracking and performance monitoring.
 *
 * - Only runs on deployed environments (not localhost)
 * - Configuration is injected at build time via Vite environment variables
 * - Gracefully skips initialization if config is missing
 */

// Get RUM configuration from Vite environment variables (injected at build time)
const rumAppId = import.meta.env.VITE_RUM_APPLICATION_ID;
const rumIdentityPoolId = import.meta.env.VITE_RUM_IDENTITY_POOL_ID;
const rumGuestRoleArn = import.meta.env.VITE_RUM_GUEST_ROLE_ARN;
const rumRegion = import.meta.env.VITE_RUM_REGION;

// Only initialize RUM if all config exists (deployed environments, not localhost)
if (rumAppId && rumIdentityPoolId && rumGuestRoleArn && rumRegion) {
  // AWS CloudWatch RUM Web Client Snippet
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (function (n: string, i: string, v: string, r: string, s: string, c: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const x: any = ((window as any).AwsRumClient = {
      q: [],
      n: n,
      i: i,
      v: v,
      r: r,
      c: c,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any)[n] = function (c: any, p: any) {
      x.q.push({ c: c, p: p });
    };
    const z = document.createElement('script');
    z.async = true;
    z.src = s;
    const firstScript = document.head.getElementsByTagName('script')[0];
    if (firstScript) {
      document.head.insertBefore(z, firstScript);
    } else {
      document.head.appendChild(z);
    }
  })(
    'cwr', // Command name
    rumAppId, // Application ID
    '1.0.0', // Application version
    rumRegion, // AWS Region
    `https://client.rum.${rumRegion}.amazonaws.com/1.17.0/cwr.js`, // RUM client URL
    {
      sessionSampleRate: 1, // 100% sampling (capture all user sessions)
      identityPoolId: rumIdentityPoolId,
      guestRoleArn: rumGuestRoleArn,
      endpoint: `https://dataplane.rum.${rumRegion}.amazonaws.com`,
      telemetries: ['errors', 'performance', 'http'], // What to monitor
      allowCookies: true, // Allow cookies for session tracking
      enableXRay: true, // Enable AWS X-Ray integration for distributed tracing
    },
  );

  console.log('[CloudWatch RUM] Initialized successfully');
} else {
  console.log('[CloudWatch RUM] Skipped initialization (running on localhost)');
}
